module.exports = __webpack_public_path__ + "static/media/who_wants_to_be_a_millionaire.btg.c9a9b102.jpeg";